export type WarriorAccent = 'navy' | 'teal' | 'gold' | 'default';

export interface WarriorProfile {
  slug: string;
  name: string;
  role: string;
  headline: string;
  hook: string;
  storySnippet: string;
  to: string;
  cta: string;
  accent: WarriorAccent;
  social: {
    facebook?: string;
    tiktok?: string;
    youtube?: string;
    instagram?: string;
  };
  stats: {
    videos: number;
    languages: number;
    countries: number;
  };
}

export const WARRIOR_TOP_BG: Record<WarriorAccent, string> = {
  navy:
    'linear-gradient(180deg, rgba(26,82,118,0.18) 0%, rgba(26,82,118,0.18) 62%, rgba(12,56,84,0.72) 100%), repeating-linear-gradient(135deg, rgba(255,255,255,0.20) 0 2px, rgba(255,255,255,0) 2px 10px)',
  teal:
    'linear-gradient(180deg, rgba(20,143,119,0.18) 0%, rgba(20,143,119,0.18) 62%, rgba(10,84,70,0.70) 100%), repeating-linear-gradient(135deg, rgba(255,255,255,0.20) 0 2px, rgba(255,255,255,0) 2px 10px)',
  gold:
    'linear-gradient(180deg, rgba(212,172,13,0.16) 0%, rgba(212,172,13,0.16) 62%, rgba(138,111,8,0.64) 100%), repeating-linear-gradient(135deg, rgba(255,255,255,0.22) 0 2px, rgba(255,255,255,0) 2px 10px)',
  default:
    'linear-gradient(180deg, rgba(26,82,118,0.18) 0%, rgba(26,82,118,0.18) 62%, rgba(12,56,84,0.72) 100%), repeating-linear-gradient(135deg, rgba(255,255,255,0.20) 0 2px, rgba(255,255,255,0) 2px 10px)',
};

export const WARRIORS: WarriorProfile[] = [
  {
    slug: 'kyle',
    name: 'Kyle Terence Abanto',
    role: 'Filmmaker · Transplant Survivor',
    headline: 'A thousand dialysis sessions and a second chance at life.',
    hook: 'I had over 1,000 dialysis sessions. Your donation is what kept me alive.',
    storySnippet:
      'Kyle shares the reality of long-term dialysis and what it takes for families to keep treatment going. He uses film and storytelling to bring patient voices into every campaign.',
    to: '/warriors/kyle',
    cta: "Watch Kyle's Story",
    accent: 'navy',
    social: { youtube: '#', facebook: '#' },
    stats: { videos: 12, languages: 2, countries: 4 },
  },
  {
    slug: 'jennie',
    name: 'Jennie Hayson Maasin',
    role: 'Teacher · CKD Educator',
    headline: 'Turning CKD education into daily family action.',
    hook: 'As a teacher, I know education saves lives. So does your donation.',
    storySnippet:
      'Jennie leads practical CKD awareness sessions for caregivers and patient circles. Her work translates medical information into simple guidance families can apply immediately.',
    to: '/warriors/jennie',
    cta: "Watch Jennie's Story",
    accent: 'teal',
    social: { facebook: '#', instagram: '#' },
    stats: { videos: 9, languages: 3, countries: 3 },
  },
  {
    slug: 'nasif',
    name: 'Nasif P. Lomondot',
    role: 'Community Educator · Multilingual Advocate',
    headline: 'Meeting families where they are, in the language they trust.',
    hook: 'In Cebuano, Filipino, Maranao — I say the same thing: we need your help.',
    storySnippet:
      'Nasif bridges language and access barriers for vulnerable CKD communities. He helps patients and caregivers navigate treatment realities with clear, culturally grounded communication.',
    to: '/warriors/nasif',
    cta: "Watch Nasif's Story",
    accent: 'gold',
    social: { facebook: '#', tiktok: '#', youtube: '#' },
    stats: { videos: 15, languages: 4, countries: 5 },
  },
  {
    slug: 'justin',
    name: 'Justin Thomas Caluag',
    role: 'Content Creator · Storyteller',
    headline: 'Making CKD impact visible through digital storytelling.',
    hook: 'I use every tool I have to make sure you see what I see — lives worth saving.',
    storySnippet:
      'Justin documents frontline CKD stories and campaign outcomes so supporters can see exactly how contributions translate into treatment support and patient continuity.',
    to: '/warriors/justin',
    cta: "Watch Justin's Story",
    accent: 'default',
    social: { youtube: '#', instagram: '#', tiktok: '#' },
    stats: { videos: 18, languages: 2, countries: 6 },
  },
];
